import React from "react"
import moment from "moment"
import HomeChart from "./charts"

import { mall } from "../../data/overview"
import BDApi from "../../data/bd"
import Clock from "./clock"

import Building from "../Building"
import Shop from "../Shop"
import Car from "../Car"
import Trajectory from "../Trajectory"
import Util from "../../util/util"
// import FullScreen from "./fullScreen"
import "./index.scss"
const BMap = window.BMap
const echarts = window.echarts
class Home extends React.Component {
  constructor(props) {
    super(props)
    let lastHour = moment().subtract("hour", 1).hours()
    this.state = {
      hour: lastHour,
      lastHour,
      tipStyle: null,
    }
  }
  onHourChange = (hour) => {
    this.setState({ hour })
    this.renderHeat(hour)
  }
  onLastHourChange = (lastHour) => {
    this.setState({ lastHour })
  }
  componentDidMount() {
    let me = this
    let history = this.props.history
    var dom = this.refs.$map
    var myChart = (this.myChart = echarts.init(dom))
    var tip = [{ name: "4s", value: 50 }]
    var geoCoordMap = { "4s": [121.505869, 31.211253] }
    var convertData = function (data) {
      var res = []
      for (var i = 0; i < data.length; i++) {
        var geoCoord = geoCoordMap[data[i].name]
        if (geoCoord) {
          res.push({
            name: data[i].name,
            value: geoCoord.concat(data[i].value),
          })
        }
      }
      return res
    }
    myChart.setOption({
      bmap: {
        center: [121.495418, 31.241972],
        maxZoom: 16,
        minZoom: 16,
        zoom: 16,
        roam: true,
        enableClick: false,
      },
      visualMap: {
        show: false,
        top: "top",
        min: 0,
        max: 5,
        seriesIndex: 0,
        calculable: true,
        inRange: { color: ["blue", "blue", "green", "yellow", "red"] },
      },
      series: [
        {
          type: "heatmap",
          coordinateSystem: "bmap",
          data: [],
          pointSize: 5,
          blurSize: 6,
        },
        {
          type: "lines",
          coordinateSystem: "bmap",
          polyline: true,
          data: [],
          lineStyle: {
            normal: {
              width: 0,
              color: function (ai) {
                var ag = ai.dataIndex
                var t = [
                  "rgba(64,224,208,1)",
                  "rgba(235,122,255,1)",
                  "rgba(243,130,49,1)",
                  "rgba(255,34,34,1)",
                  "rgba(176,196,222,1)",
                  "rgba(20,60,136,1)",
                ]
                var aj = ag + ""
                var ae = [14, 23, 20, 17, 15, 11]
                if (ag < 10) {
                  aj = "0" + aj
                }
                var ah = aj.substring(aj.length - 2)
                var af = parseInt(ah)
                if (af <= ae[0]) {
                  return t[0]
                } else {
                  if (af > ae[0] && af <= ae[0] + ae[1]) {
                    return t[1]
                  } else {
                    if (af > ae[0] + ae[1] && af <= ae[0] + ae[1] + ae[2]) {
                      return t[2]
                    } else {
                      if (
                        af > ae[0] + ae[1] + ae[2] &&
                        af <= ae[0] + ae[1] + ae[2] + ae[3]
                      ) {
                        return t[3]
                      } else {
                        if (
                          af > ae[0] + ae[1] + ae[2] + ae[3] &&
                          af <= ae[0] + ae[1] + ae[2] + ae[3] + ae[4]
                        ) {
                          return t[4]
                        } else {
                          if (
                            af > ae[0] + ae[1] + ae[2] + ae[3] + ae[4] &&
                            af <= ae[0] + ae[1] + ae[2] + ae[3] + ae[4] + ae[5]
                          ) {
                            return t[5]
                          }
                        }
                      }
                    }
                  }
                }
              },
            },
          },
          effect: {
            constantSpeed: 3,
            show: true,
            trailLength: 0.2,
            symbolSize: 5,
            animation: false,
          },
          zlevel: 1,
        },
        {
          type: "lines",
          coordinateSystem: "bmap",
          polyline: true,
          data: [],
          lineStyle: {
            normal: {
              width: 0,
            },
          },
          effect: {
            constantSpeed: 4,
            show: true,
            trailLength: 0,
            symbolSize: [26 / 2, 52 / 2],
            symbol: "image://img/Friday.png",
          },
          zlevel: 1,
        },
        {
          name: "marker",
          type: "scatter",
          coordinateSystem: "bmap",
          symbol: "pin", //气泡
          symbolSize: 40,
          label: {
            normal: {
              textStyle: {
                fontWeight: "bold",
                color: "#111",
              },
              show: true,
              position: "inside",
              formatter: "{b}",
            },
          },
          itemStyle: {
            normal: {
              color: "#3f97f6", //标志颜色
            },
          },
          zlevel: 1,
          data: convertData(tip),
        },
        {
          name: "4s distance",
          type: "effectScatter",
          coordinateSystem: "bmap",
          data: convertData(tip),
          symbolSize: 5,
          showEffectOn: "render",
          rippleEffect: {
            brushType: "fill",
            period: 7,
            scale: 26,
          },
          hoverAnimation: true,
          label: {
            normal: {
              formatter: "{b}",
              position: "right",
              show: false,
            },
          },
          itemStyle: {
            normal: {
              color: "#FF3030",
              borderWidth: 1000,
              shadowBlur: 100,
              shadowColor: "#FF3030",
            },
          },
          zlevel: 1,
        },
      ],
    })
    var ecModel = myChart._model
    var bmap = null
    ecModel.eachComponent("bmap", function (bmapModel) {
      if (bmap === null) {
        bmap = bmapModel.getBMap()
      }
    })

    bmap.setMaxZoom(18)
    bmap.clearHotspots()
    bmap.closeInfoWindow()
    Util.registerChartsResize(myChart)
    // console.log(bmap)
    //添加自定义的网格线
    var tileLayer = new BMap.TileLayer({
      isTransparentPng: true,
    })
    tileLayer.getTilesUrl = function (tileCoord, zoom) {
      // var x = tileCoord.x
      // var y = tileCoord.y
      return "http://lbsyun.baidu.com/jsdemo/img/border.png"
    }
    bmap.addTileLayer(tileLayer)
    // 添加商场名字，边界
    var polygons = []
    mall.forEach((d) => {
      let overlay = new ComplexCustomOverlay(
        new BMap.Point(...d.center),
        d.name
      )
      bmap.addOverlay(overlay)

      let polygon = new BMap.Polygon(
        d.bounds.map((p) => new BMap.Point(...p)),
        {
          strokeColor: "red",
          fillColor: "#000",
        }
      )
      polygons.push(polygon)
      bmap.addOverlay(polygon)
    })
    // 监听商场点击  mychart on click 也会触发此事件
    bmap.addEventListener("click", function (e) {
      let target = null
      for (var i in polygons) {
        let p = polygons[i]
        if (p.getBounds().containsPoint(e.point)) {
          target = i
          break
        }
      }

      if (target) {
        let st = mall[target]
        if (st) {
          let type = "shop"
          if (st.id === 1) {
            type = "building"
          }
          history.push(["/", type, "/", st.id].join(""))
        }
      }
    })

    myChart.on("click", function (params) {
      if (params.seriesIndex === 2) {
        history.push("/trajectory")
      }
      if (params.seriesIndex === 3) {
        history.push("/car4s")
      }
    })
    myChart.on("mouseover", function (params) {
      if (params.seriesIndex === 2) {
        let e = params.event.event
        let s = { left: e.clientX + 10, top: e.clientY + 10 }
        me.setState({ tipStyle: s })
      }
    })
    myChart.on("mouseout", function (params) {
      if (params.seriesIndex === 2) {
        me.setState({ tipStyle: null })
      }
    })
    this.renderTra()
    this.renderHeat(this.state.hour)
  }

  /**
   * 轨迹
   */
  renderTra() {
    let myChart = this.myChart
    BDApi.getTrajectory().then((d) => {
      var mapo = myChart.getOption()
      mapo.series[1].data = d
      mapo.series[2].data = [d[609]]
      myChart.setOption(mapo)
    })
  }
  /**
   * 热力
   */
  renderHeat(hour) {
    let myChart = this.myChart
    BDApi.getHeat(hour).then((d) => {
      var mapo = myChart.getOption()
      mapo.series[0].data = d
      myChart.setOption(mapo)
    })
  }
  /**
   *关闭商场
   *
   * @memberof Home
   */
  onCloseModal = () => {
    this.props.history.push("/")
  }
  getSelectedShop() {
    let { subModel } = this.props.match.params
    return mall[parseInt(subModel)]
  }
  getModalPage() {
    let { model } = this.props.match.params

    let selectedShop = this.getSelectedShop()
    switch (model) {
      case "building":
        return <Building onCloseModal={this.onCloseModal} />
      case "shop":
        return (
          <Shop
            single
            onCloseModal={this.onCloseModal}
            id={selectedShop.id}
            name={selectedShop.name}
          />
        )
      case "car4s":
        return <Car onCloseModal={this.onCloseModal} />
      case "trajectory":
        return <Trajectory onCloseModal={this.onCloseModal} />
      default:
        return null
    }
  }

  render() {
    let { hour, lastHour, tipStyle } = this.state
    let selectedShop = this.getSelectedShop()
    return (
      <div className="page p-home">
        <div className="page-inner">
          <div className="header">
            WAYZ Location Graph 位置知识图谱
            {/* <FullScreen /> */}
          </div>
          <div className="content">
            <Clock onHourChange={this.onLastHourChange} hour={hour} />
            <div className="map-container" ref="$map" />
            <HomeChart
              onHourChange={this.onHourChange}
              selectedShop={selectedShop}
              hour={hour}
              lastHour={lastHour}
            />
          </div>
        </div>
        <div>{this.getModalPage()}</div>
        {tipStyle ? (
          <div className="carReport" style={tipStyle}>
            <p>居住地：虹叶花苑</p>
            <p>工作地：上海师大</p>
            <p>职业：教师</p>
          </div>
        ) : null}
      </div>
    )
  }
}

export default Home

function ComplexCustomOverlay(point, text) {
  this._point = point
  this._text = text
}

ComplexCustomOverlay.prototype = new BMap.Overlay()
ComplexCustomOverlay.prototype.initialize = function (map) {
  this._map = map
  var div = (this._div = document.createElement("div"))
  div.style.position = "absolute"
  div.style.zIndex = 999
  // div.style.zIndex = BMap.Overlay.getZIndex(this._point.lat);
  div.style.backgroundColor = "#3D48C1"
  // div.style.border = "1px solid #BC3B3A"
  div.style.color = "white"
  // div.style.height = "24px"
  div.style.padding = "5px 10px"
  div.style.lineHeight = "18px"
  div.style.whiteSpace = "nowrap"
  div.style.MozUserSelect = "none"
  div.style.fontSize = "10px"
  div.style.borderRadius = "8px"

  var span = (this._span = document.createElement("span"))
  div.appendChild(span)
  span.appendChild(document.createTextNode(this._text))

  var arrow = (this._arrow = document.createElement("div"))
  // arrow.style.background =
  //   "url(http://map.baidu.com/fwmap/upload/r/map/fwmap/static/house/images/label.png) no-repeat"
  arrow.style.backgroundColor = "#3D48C1"
  arrow.style.position = "absolute"
  arrow.style.width = "11px"
  arrow.style.height = "10px"
  arrow.style.top = "22px"
  arrow.style.left = "15px"
  arrow.style.overflow = "hidden"
  arrow.style.transform = "rotate(-45deg)"
  div.appendChild(arrow)
  map.getPanes().labelPane.appendChild(div)
  return div
}

ComplexCustomOverlay.prototype.draw = function () {
  var map = this._map
  var pixel = map.pointToOverlayPixel(this._point)
  this._div.style.left = pixel.x - parseInt(this._arrow.style.left) + "px"
  this._div.style.top = pixel.y - 30 + "px"
}
